{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Μεταφορά σε χειριστή",
    "MESSAGE": "Συνδέστε με με έναν χειριστή"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Κατέβασμα",
      "UPLOADING": "Ανέβασμα..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Καταχώρηση"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Επαναποστολή μηνύματος",
      "ERROR_MESSAGE": "Αδυναμία αποστολής! Προσπαθήστε ξανά"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Αξιολογήστε την ποιότητα αυτής της απάντησης"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Παρακαλώ περιμένετε να συνδεθεί ένας πράκτορας"
  },
  "ROBOT_CHECK": {
    "TITLE": "Γρήγορος έλεγχος ασφαλείας",
    "DESCRIPTION": "Παρακαλώ ολοκληρώστε τον παρακάτω έλεγχο.",
    "VERIFYING": "Επαλήθευση…",
    "ERROR": "Αυτό δεν λειτούργησε. Παρακαλώ προσπαθήστε ξανά.",
    "RETRY": "Προσπαθήστε ξανά"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Είμαστε online",
    "OFFLINE": "Προς το παρόν, είμαστε εκτός",
    "ONLINE_WITH_BOT": "Η ομάδα και ο βοηθός ΑΙ μας είναι συνδεδεμένοι",
    "OFFLINE_WITH_BOT": "Ο βοηθός ΑΙ μας είναι εδώ για να βοηθήσει",
    "BOT_ONLY_REPLY": "Απαντά αμέσως"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Τυπικά έχετε απάντηση σε μερικά λεπτά",
    "IN_A_FEW_HOURS": "Τυπικά έχετε απάντηση σε μερικές σε μερικές ώρες",
    "IN_A_DAY": "Τυπικά έχετε απάντηση σε μία ημέρα",
    "BACK_IN": "Θα είμαστε ξανά online"
  },
  "DAY_NAMES": {
    "SUNDAY": "Κυριακή",
    "MONDAY": "Δευτέρα",
    "TUESDAY": "Τρίτη",
    "WEDNESDAY": "Τετάρτη",
    "THURSDAY": "Πέμπτη",
    "FRIDAY": "Παρασκευή",
    "SATURDAY": "Σάββατο"
  },
  "START_CONVERSATION": "Έναρξη Συνομιλίας",
  "END_CONVERSATION": "Τέλος Συνομιλίας",
  "CONTINUE_CONVERSATION": "Συνέχιση συνομιλίας",
  "YOU": "Εσείς",
  "START_NEW_CONVERSATION": "Έναρξη νέας συνομιλίας",
  "RESOLVE_LATER": "Θα λύσουμε αυτό το θέμα μέσω email/τηλεφώνου. Τώρα θέλω να ρωτήσω για κάτι άλλο.",
  "VIEW_UNREAD_MESSAGES": "Έχετε μη αναγνωσμένα μηνύματα",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Δείτε τα νέα μηνύματα",
    "CLOSE_MESSAGES_BUTTON": "Κλείσιμο",
    "COMPANY_FROM": "από",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Συνομιλήστε μαζί μας"
  },
  "POWERED_BY": "με την δύναμη του {brandName}",
  "EMAIL_PLACEHOLDER": "Παρακαλώ εισάγετε το email σας",
  "CHAT_PLACEHOLDER": "Πληκτρολογήστε το μήνυμά σας",
  "TODAY": "Σήμερα",
  "YESTERDAY": "Χτες",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Πλήρες Όνομα",
        "PLACEHOLDER": "Παρακαλώ συμπληρώστε το πλήρες όνομα σας",
        "REQUIRED_ERROR": "Απαιτείται πλήρες όνομα"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Διεύθυνση Email",
        "PLACEHOLDER": "Παρακαλούμε εισάγετε τη διεύθυνση email σας",
        "REQUIRED_ERROR": "Απαιτείται διεύθυνση email",
        "VALID_ERROR": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email"
      },
      "PHONE_NUMBER": {
        "LABEL": "Αριθμός Τηλεφώνου",
        "PLACEHOLDER": "Παρακαλώ εισάγετε τον αριθμό του τηλεφώνου σας",
        "REQUIRED_ERROR": "Απαιτείται ο αριθμός τηλεφώνου",
        "DIAL_CODE_VALID_ERROR": "Παρακαλώ επιλέξτε κωδικό χώρας",
        "VALID_ERROR": "Παρακαλώ εισάγετε έναν έγκυρο αριθμό τηλεφώνου",
        "DROPDOWN_EMPTY": "Δεν βρέθηκαν αποτελέσματα",
        "DROPDOWN_SEARCH": "Αναζήτηση χώρας"
      },
      "MESSAGE": {
        "LABEL": "Μήνυμα",
        "PLACEHOLDER": "Παρακαλώ εισάγετε το μήνυμά σας",
        "ERROR": "Πολύ σύντομο μήνυμα"
      }
    },
    "CAMPAIGN_HEADER": "Παρακαλώ δώστε το όνομα και το email σας πριν ξεκινήσετε την συνομιλία",
    "IS_REQUIRED": "είναι απαραίτητο",
    "REQUIRED": "Υποχρεωτικό",
    "REGEX_ERROR": "Παρακαλώ εισάγετε μια έγκυρη τιμή"
  },
  "FILE_SIZE_LIMIT": "Το αρχείο υπερβαίνει το όριο συνημμένου {MAXIMUM_FILE_UPLOAD_SIZE}",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Μη έγκυρο πεδίο"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Αναζήτηση emojis",
    "NOT_FOUND": "Κανένα emoji δεν ταιριάζει με την αναζήτησή σας",
    "ARIA_LABEL": "Επιλογή emoji"
  },
  "CSAT": {
    "TITLE": "Αξιολογήστε τη συνομιλία σας",
    "SUBMITTED_TITLE": "Ευχαριστούμε για την υποβολή της αξιολόγησης",
    "PLACEHOLDER": "Πείτε μας περισσότερα..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Αίτηση μεταγραφής συνομιλίας",
    "SEND_EMAIL_SUCCESS": "Η μεταγραφή της συνομιλίας έχει αποσταλεί επιτυχώς",
    "SEND_EMAIL_ERROR": "Υπήρξε ένα σφάλμα, παρακαλώ προσπαθήστε ξανά"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Δημοφιλή άρθρα",
    "VIEW_ALL_ARTICLES": "Προβολή όλων των άρθρων",
    "IFRAME_LOAD_ERROR": "Παρουσιάστηκε σφάλμα κατά τη φόρτωση του άρθρου. Παρακαλώ ανανεώστε τη σελίδα και προσπαθήστε ξανά."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Άνοιγμα",
      "BUY": "Αγορά"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Μήνυμα εικόνας"
    },
    "audio": {
      "CONTENT": "Μήνυμα ήχου"
    },
    "video": {
      "CONTENT": "Μήνυμα βίντεο"
    },
    "file": {
      "CONTENT": "Επισυναπτόμενο αρχείο"
    },
    "location": {
      "CONTENT": "Θέση"
    },
    "fallback": {
      "CONTENT": "έχει μοιράσει ένα σύνδεσμο"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Απάντηση σε:"
  }
}
